<div class="main">
  <div>
    <p class="title-section">Primaria</p>
  </div>
  <div class="loading-shade" *ngIf="isLoading">
    <mat-spinner *ngIf="isLoading"></mat-spinner>
  </div>
  <table mat-table [dataSource]="cementings">
    <ng-container matColumnDef="assemblySize">
      <mat-header-cell *matHeaderCellDef>
        Diámetro de sección <br />de casing [pulg]
      </mat-header-cell>
      <mat-cell *matCellDef="let cementing">
        {{ cementing.assemblySize }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="stageNo">
      <mat-header-cell *matHeaderCellDef> Núm. de etapa </mat-header-cell>
      <mat-cell *matCellDef="let cementing"> {{ cementing.stageNo }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="isPlugBumped">
      <mat-header-cell *matHeaderCellDef>
        ¿Confirma <br />Tope Tapón?
      </mat-header-cell>
      <mat-cell *matCellDef="let cementing">
        <mat-slide-toggle
          [checked]="cementing.isPlugBumped == 'Si'"
          [disabled]="true"
        >
          {{ cementing.isPlugBumped }}
        </mat-slide-toggle>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="mdTopStage">
      <mat-header-cell *matHeaderCellDef>
        TOC <br />Programa [m]
      </mat-header-cell>
      <mat-cell *matCellDef="let cementing"
        ><span class="table-numbers-right-align">
          {{ cementing.mdTopStage | number : "1.2-2" }}
        </span></mat-cell
      >
    </ng-container>

    <ng-container matColumnDef="tocMd">
      <mat-header-cell *matHeaderCellDef> CBL Toc [m] </mat-header-cell>
      <mat-cell *matCellDef="let cementing"
        ><span class="table-numbers-right-align">
          {{ cementing.tocMd | number : "1.2-2" }}
        </span></mat-cell
      >
    </ng-container>

    <ng-container matColumnDef="pressureHeld">
      <mat-header-cell *matHeaderCellDef>
        Presión Final <br />Programada [psi]
      </mat-header-cell>
      <mat-cell *matCellDef="let cementing"
        ><span class="table-numbers-right-align">
          {{ cementing.pressureHeld | number : "1.2-2" }}
        </span></mat-cell
      >
    </ng-container>

    <ng-container matColumnDef="finalPressure">
      <mat-header-cell *matHeaderCellDef>
        Presión Final <br />Real [psi]
      </mat-header-cell>
      <mat-cell *matCellDef="let cementing"
        ><span class="table-numbers-right-align">
          {{ cementing.finalPressure | number : "1.2-2" }}
        </span></mat-cell
      >
    </ng-container>

    <ng-container matColumnDef="makeTopJob">
      <mat-header-cell *matHeaderCellDef>
        ¿Realiza <br />TOP Job?
      </mat-header-cell>
      <mat-cell *matCellDef="let cementing; let i = index">
        <mat-radio-group
          class="radio-button-group-top-job"
          *ngIf="seeTopJobOptions(cementing.topJobDescription)"
          [disabled]="readOnlyContent || cementing.topJobDescription == 'Si'"
          [(ngModel)]="cementings[i].makeTopJob"
          (change)="enableSaveButton(i, cementings[i].comments, $event.value)"
        >
          <mat-radio-button
            class="radio-button-option-no"
            [checked]="
              cementing.makeTopJob == 'false' &&
              cementing.topJobDescription == 'Indeterminado'
            "
            value="false"
            >No</mat-radio-button
          >
          <mat-radio-button
            [checked]="
              cementing.topJobDescription == 'Si' ||
              (cementing.topJobDescription == 'Si' &&
                cementing.makeTopJob == 'true')
            "
            value="true"
            >Si</mat-radio-button
          >
        </mat-radio-group>
        <span
          *ngIf="seeMandatorySeleccionText(cementing.topJobDescription)"
          class="mandatory-text-notification"
          >* Esta selección es obligatoria
        </span>
        <span
          *ngIf="seeTopJobTextDescription(cementing.topJobDescription)"
          class="text-type-disable"
          [matTooltip]="tooltipDescription"
          matTooltipPosition="above"
        >
          {{ cementing.topJobDescription }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell
        *matCellDef="let cementing; let i = index"
        [ngClass]="'mat-column-save'"
      >
        <span class="row-buttons">
          <button
            mat-mini-fab
            (click)="
              openComments(cementings[i].comments, i, $event, readOnlyContent)
            "
            class="comment-ho-icon"
          >
            <mat-icon class="material-icons-outlined"
              >chat_bubble_outline</mat-icon
            >
            <div class="circle-comments" *ngIf="cementings[i].comments"></div>
            <span class="comment">Comentar</span>
          </button>
        </span>
        <button
          mat-mini-fab
          (click)="saveCementing(cementing, i)"
          class="save-ho-icon"
          [disabled]="isDisabled[i]"
        >
          <mat-icon class="material-icons-outlined">save</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="noData">
      <mat-footer-cell *matFooterCellDef colspan="9">
        <div class="footer">
          <div class="footer-no-data">No se encontraron datos.</div>
          <div *ngIf="showFooterNoDataOrign" class="footer-no-data-origin">
            De existir datos en el sistema de origen, podrás visualizarlos acá.
          </div>
        </div>
      </mat-footer-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    <mat-footer-row
      *matFooterRowDef="['noData']"
      [ngClass]="{ 'hide-footer': hideFooter }"
    ></mat-footer-row>
  </table>
  <br />
  <div>
    <p class="title-section">Squeeze</p>
  </div>
  <table mat-table [dataSource]="squeezes">
    <ng-container matColumnDef="assemblySize">
      <mat-header-cell *matHeaderCellDef>
        Diámetro de Sección <br />Casing [pulg]
      </mat-header-cell>
      <mat-cell *matCellDef="let squeeze">
        {{ squeeze.assemblySize }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="stageNo">
      <mat-header-cell *matHeaderCellDef> Núm. de Etapa </mat-header-cell>
      <mat-cell *matCellDef="let squeeze"> {{ squeeze.stageNo }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="squeezeSetMd">
      <mat-header-cell *matHeaderCellDef>
        MD Base del <br />Punzado [m]
      </mat-header-cell>
      <mat-cell *matCellDef="let squeeze">
        {{ squeeze.squeezeSetMd }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="squeezeObjective">
      <mat-header-cell *matHeaderCellDef> Objetivo </mat-header-cell>
      <mat-cell *matCellDef="let squeeze">
        {{ squeeze.squeezeObjective }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="metodoEvaluacion">
      <mat-header-cell *matHeaderCellDef>
        Método de Evaluación
      </mat-header-cell>
      <mat-cell *matCellDef="let squeeze">
        {{ squeeze.metodoEvaluacion }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="prodSlurryQuality">
      <mat-header-cell *matHeaderCellDef>
        Resultado de la<br />Evaluación
      </mat-header-cell>
      <mat-cell *matCellDef="let squeeze">
        {{ squeeze.prodSlurryQuality }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell
        *matCellDef="let squeeze; let i = index"
        [ngClass]="'mat-column-save'"
      >
        <span class="row-buttons">
          <button
            mat-mini-fab
            (click)="
              openCommentsSqueezes(
                squeezes[i].comments,
                i,
                $event,
                readOnlyContent
              )
            "
            class="comment-ho-icon"
          >
            <mat-icon class="material-icons-outlined"
              >chat_bubble_outline</mat-icon
            >
            <div class="circle-comments" *ngIf="squeezes[i].comments"></div>
            <span class="comment">Comentar</span>
          </button>
        </span>
        <button
          mat-mini-fab
          (click)="saveCementingSqueeze(squeeze, i)"
          class="save-ho-icon"
          [disabled]="isDisabledSqueezes[i]"
        >
          <mat-icon class="material-icons-outlined">save</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="noData">
      <mat-footer-cell *matFooterCellDef colspan="7">
        <div class="footer">
          <div class="footer-no-data">No se encontraron datos.</div>
          <div *ngIf="showFooterNoDataOrign" class="footer-no-data-origin">
            De existir datos en el sistema de origen, podrás visualizarlos acá.
          </div>
        </div>
      </mat-footer-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumnsSqueeze"></mat-header-row>
    <mat-row
      *matRowDef="let rowSqueeze; columns: displayedColumnsSqueeze"
    ></mat-row>
    <mat-footer-row
      *matFooterRowDef="['noData']"
      [ngClass]="{ 'hide-footer': hideFooterSqueezes }"
    ></mat-footer-row>
  </table>
  <br />
  <div>
    <p class="title-section">Tapones</p>
  </div>
  <table mat-table [dataSource]="plugs">
    <ng-container matColumnDef="assemblySize">
      <mat-header-cell *matHeaderCellDef>
        Diámetro de Sección <br />Casing [pulg]
      </mat-header-cell>
      <mat-cell *matCellDef="let plug"> {{ plug.assemblySize }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="stageNo">
      <mat-header-cell *matHeaderCellDef> Núm. de<br />Etapa </mat-header-cell>
      <mat-cell *matCellDef="let plug"> {{ plug.stageNo }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="estTop">
      <mat-header-cell *matHeaderCellDef> Tope </mat-header-cell>
      <mat-cell *matCellDef="let plug"> {{ plug.estTop }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="estBottom">
      <mat-header-cell *matHeaderCellDef> Base </mat-header-cell>
      <mat-cell *matCellDef="let plug"> {{ plug.estBottom }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="stageType">
      <mat-header-cell *matHeaderCellDef> Tipo </mat-header-cell>
      <mat-cell *matCellDef="let plug"> {{ plug.stageType }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="plugObjective">
      <mat-header-cell *matHeaderCellDef> Objetivo </mat-header-cell>
      <mat-cell *matCellDef="let plug"> {{ plug.plugObjective }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="metodoEvaluacion">
      <mat-header-cell *matHeaderCellDef>
        Método de<br />Evaluación
      </mat-header-cell>
      <mat-cell *matCellDef="let plug"> {{ plug.metodoEvaluacion }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="tocMd">
      <mat-header-cell *matHeaderCellDef> CBL TOC [m] </mat-header-cell>
      <mat-cell *matCellDef="let plug"> {{ plug.tocMd }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="prodSlurryQuality">
      <mat-header-cell *matHeaderCellDef>
        Resultado de la<br />Evaluación
      </mat-header-cell>
      <mat-cell *matCellDef="let plug"> {{ plug.prodSlurryQuality }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell
        *matCellDef="let plug; let i = index"
        [ngClass]="'mat-column-save'"
      >
        <span class="row-buttons">
          <button
            mat-mini-fab
            (click)="
              openCommentsPlugs(plugs[i].comments, i, $event, readOnlyContent)
            "
            class="comment-ho-icon"
          >
            <mat-icon class="material-icons-outlined"
              >chat_bubble_outline</mat-icon
            >
            <div class="circle-comments" *ngIf="plugs[i].comments"></div>
            <span class="comment">Comentar</span>
          </button>
        </span>
        <button
          mat-mini-fab
          (click)="saveCementingPlug(plug, i)"
          class="save-ho-icon"
          [disabled]="isDisabledPlugs[i]"
        >
          <mat-icon class="material-icons-outlined">save</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="noData">
      <mat-footer-cell *matFooterCellDef colspan="10">
        <div class="footer">
          <div class="footer-no-data">No se encontraron datos.</div>
          <div *ngIf="showFooterNoDataOrign" class="footer-no-data-origin">
            De existir datos en el sistema de origen, podrás visualizarlos acá.
          </div>
        </div>
      </mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="firstEmpty">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
    </ng-container>
    <ng-container matColumnDef="secondEmpty">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="plugProgrammed">
      <mat-header-cell *matHeaderCellDef [attr.colspan]="2">
        <div class="plug-header-column">
          <span class="plug-header-text">MD Programada de Tapón</span>
        </div>
      </mat-header-cell>
    </ng-container>

    <ng-container matColumnDef="restEmpty">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
    </ng-container>

    <mat-header-row
      *matHeaderRowDef="[
        'firstEmpty',
        'secondEmpty',
        'plugProgrammed',
        'restEmpty',
        'restEmpty',
        'restEmpty',
        'restEmpty',
        'restEmpty',
        'restEmpty'
      ]"
      class="plug-header"
    ></mat-header-row>
    <mat-header-row *matHeaderRowDef="displayedColumnsPlugs"></mat-header-row>
    <mat-row *matRowDef="let rowPlug; columns: displayedColumnsPlugs"></mat-row>
    <mat-footer-row
      *matFooterRowDef="['noData']"
      [ngClass]="{ 'hide-footer': hideFooterPlugs }"
    ></mat-footer-row>
  </table>

  <!-- File Attachment -->
  <div class="cemmenting-attacment-panel" *ngIf="displayCementingAttachment">
    <p class="title-section">Reportes</p>
    <div
      class="handover-cementing-attachment"
      *ngFor="let attachment of cementingFileAttachments; let i = index"
    >
      <div class="top">
        <div class="selector">
          <mat-form-field appearance="fill">
            <mat-label>Reporte de</mat-label>
            <mat-select
              [disabled]="true"
              name="cementingAttachmentType"
              [(ngModel)]="attachment.cementingAttachmentType"
            >
              <mat-option [value]="attachment.cementingAttachmentType">
                {{
                  attachment.cementingAttachmentType.cementingAttachmentTypeName
                }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          *ngIf="
            attachment.cementingAttachmentType
              .cementingAttachmenTypeWithDescription
          "
          class="text-description"
        >
          <mat-form-field class="comment">
            <input
              [disabled]="readOnlyContent"
              matInput
              name="comment"
              maxlength="50"
              type="text"
              [(ngModel)]="attachment.cementingAttachmentDescription"
              (ngModelChange)="
                descriptionAttachmentUpdate(
                  i,
                  attachment.cementingAttachmentDescription!
                )
              "
            />
            <mat-hint>Este campo es obligatorio.</mat-hint>
          </mat-form-field>
        </div>
        <a
          class="attachment-link"
          href="{{ dhoApiUrl }}/{{ attachment?.filePath }}"
          download="{{ attachment.fileOriginalName }}"
          target="_blank"
        >
          {{ attachment?.fileOriginalName }}
        </a>
        <button
          mat-button
          [ngClass]="{ ready: true }"
          [disabled]="!attachmentTypeUpdateIsEnabled[i] || readOnlyContent"
          (click)="updateAttachment(attachment)"
        >
          LISTO
        </button>
        <button
          mat-icon-button
          [ngClass]="{ remove: true }"
          [disabled]="readOnlyContent"
          (click)="deleteCementingAttachment(attachment.fileId)"
        >
          <mat-icon class="material-icons-outlined">delete</mat-icon>
        </button>
      </div>
    </div>
    <div class="handover-cementing-attachment">
      <div class="top">
        <div class="selector">
          <mat-form-field appearance="fill">
            <mat-label>Tipo de Reporte</mat-label>
            <mat-select
              [disabled]="readOnlyContent"
              [(ngModel)]="
                this.chosenCementingAttachment.cementingAttachmentType
              "
              (selectionChange)="onSelectAttachmentType()"
            >
              <mat-option *ngIf="this.cementingAttachmentTypes.length > 0"
                >Seleccione Reporte</mat-option
              >
              <mat-option *ngIf="this.cementingAttachmentTypes.length == 0"
                >No hay más reportes disponibles</mat-option
              >
              <mat-option
                *ngFor="
                  let cementingAttachmentType of this.cementingAttachmentTypes
                "
                [value]="cementingAttachmentType"
              >
                {{ cementingAttachmentType.cementingAttachmentTypeName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          *ngIf="
            this.chosenCementingAttachment.cementingAttachmentType
              ?.cementingAttachmenTypeWithDescription
          "
          class="text-description"
        >
          <mat-form-field>
            <mat-label>Describí el reporte*</mat-label>
            <input
              matInput
              [disabled]="readOnlyContent"
              [(ngModel)]="
                this.chosenCementingAttachment.cementingAttachmentDescription
              "
              (ngModelChange)="enableDescriptionAttachmentSubmission()"
              maxlength="50"
              type="text"
            />
            <mat-hint>Este campo es obligatorio.</mat-hint>
          </mat-form-field>
        </div>
        <a
          class="attachment-link"
          href="{{ dhoApiUrl }}/{{
            this.chosenCementingAttachment.fileToUpload?.name
          }}"
          (click)="deniedDownload($event)"
        >
          {{ this.chosenCementingAttachment.fileToUpload?.name }}
        </a>
        <!-- Boton borrar-->
        <button
          mat-button
          class="delete-button"
          (click)="onFileChosenDeleted()"
          *ngIf="this.chosenCementingAttachment.fileToUpload"
          [disabled]="readOnlyContent"
        >
          <mat-icon class="material-icons-outlined">delete</mat-icon>
        </button>
        <ng-container
          *ngIf="!this.chosenCementingAttachment.fileToUpload?.name"
        >
          <input
            type="file"
            class="file-input"
            accept=".xls, .xlsx, .pdf"
            (change)="onFileChosenSelected($event)"
            #fileUpload
            style="display: none"
          />
          <div
            class="attach"
            title="Documento"
            *ngIf="!this.chosenCementingAttachment.fileToUpload?.name"
          >
            <button
              mat-button
              class="upload-button"
              (click)="fileUpload.click()"
              [disabled]="readOnlyContent"
            >
              <mat-icon class="material-icons-outlined">file_upload</mat-icon
              >Adjuntar archivo</button
            ><br />
            <span *ngIf="!this.chosenCementingAttachment.fileToUpload?.name"
              >Archivos PDF, JPG, XLSX están permitidos</span
            >
          </div>
        </ng-container>
        <button
          mat-button
          [ngClass]="{ ready: true }"
          [disabled]="isDisabledSubmit() || readOnlyContent"
          (click)="submitAttachment()"
        >
          LISTO
        </button>
      </div>
    </div>
  </div>
</div>
<app-handover-detail-cementing-icp
  [handoverId]="handover?.handoverId"
  [wellName]="handover?.wellName"
  [handoverStatusId]="handover?.handoverStatusId"
></app-handover-detail-cementing-icp>
